import DataTable from "react-data-table-component";
import React from "react";
import styled from "styled-components";

const CustomTable = styled(DataTable)`
  & .rdt_TableCell {
    & .partial {
      color: red;
    }
    & .several {
      color: blue;
    }
    & .active {
      color: ${({ theme }) => theme.brandColor};
      font-weight: 900;
    }
    & .positive {
      color: ${({ theme }) => theme.posGreen};
      font-weight: 900;
    }
    & .small {
      font-size: 0.6rem;
    }
  }
  & .rdt_TableHeader {
    display: none;
  }

  & .rdt_Table {
    margin: 0;
  }
`;

const conditionalRowStyles = [
  {
    when: (row) => row.activationStatus === true,
    style: {
      backgroundColor: "DarkSeaGreen",
      color: "white",
    },
  },
];
function sortingDescByDate(props) {
  if (props.title === "Customer Payments") {
    let arr = [props.data][0];
    console.log(arr);
    arr.sort(function (a, b) {
      return new Date(b.paidAt).getTime() - new Date(a.paidAt).getTime();
    });
    console.log(arr);
  }
}
function FinanceTable(props) {
  sortingDescByDate(props);
  console.log("FinanceTable", props);
  console.log(props.columns);
  console.log("props.sortFunction", props.sortFunction);
  const safeGet = (obj, path) => {
    try {
      if (!obj || !path) return undefined;
      return path
        .split(".")
        .reduce((s, p) => (s && s[p] !== undefined ? s[p] : undefined), obj);
    } catch (e) {
      return undefined;
    }
  };

  const sanitizedColumns = Array.isArray(props.columns)
    ? props.columns.map((c, idx) => {
        const col = { ...c };
        if (typeof col.selector === "string") {
          const path = col.selector;
          col.selector = (row) => safeGet(row, path);
        }
        if (col.format && typeof col.format !== "function") delete col.format;
        if (col.cell && typeof col.cell !== "function") delete col.cell;
        return col;
      })
    : [];
  return (
    <div className="data-table">
      <CustomTable
        title={props.title}
        columns={sanitizedColumns}
        conditionalRowStyles={conditionalRowStyles}
        data={props.data}
        responsive={true}
        pagination={!props.noPagination && true}
        paginationPerPage={props.paginationPerPage || 10}
        dense={props.dense}
        fixedHeader={props.fixedHeader || false}
        paginationRowsPerPageOptions={
          props.paginationRowsPerPageOptions || [5, 10, 30, 50, 100]
        }
        highlightOnHover={true}
        sortFunction={
          props.sortFunction
            ? props.sortFunction
            : (rows) => {
                if (
                  props.title === "Customer Payments" &&
                  Array.isArray(rows)
                ) {
                  return [...rows].sort(function (a, b) {
                    return (
                      new Date(b.paidAt).getTime() -
                      new Date(a.paidAt).getTime()
                    );
                  });
                }
                return rows;
              }
        }
        onSort={(column, sortDirection) => {
          if (typeof props.onSort === "function")
            props.onSort(column, sortDirection);
        }}
        onRowClicked={(e) => (props.onRowClick ? props.onRowClick(e) : "")}
        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
          console.log("ONPAGE ", currentRowsPerPage, currentPage);
        }}
        onChangePage={(page, totalRows) => {
          console.log("ON PAGE CHANGE ", page, totalRows);
        }}
      />
    </div>
  );
}

export default FinanceTable;

/**
 *   onChangePage={() => {
          if (props.onChangePage) {
          }
        }}
 */
